export default __webpack_public_path__ + "static/media/4.e20a9888.jpg";